import { compact } from 'lodash/fp';

export const splitEmailAddresses = (emailAddresses: string[]) => {
  return compact(
    emailAddresses.flatMap((str) => str.split(/,|;/)).map((emailAddress) => emailAddress.trim()),
  );
};
